export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6229.8f4149f0.jpg";